import { createI18n } from 'vue-i18n'
import { messages } from '../lang/locales'

const instance = createI18n({
  locale: shared.app.locale,
  legacy: false,
  fallbackLocale: 'en',
  messages,
})

export default instance

export const i18n = instance.global
